import { forwardRef, createElement } from 'react';
import { mergeRefs } from '../../../utils/mergeRefs.js';
import { Trigger as Trigger$1 } from '@radix-ui/react-dialog';
import { useCurrentDialog } from '../Context.js';

const Trigger = /*#__PURE__*/forwardRef(function DialogTrigger(props, ref) {
  const dialog = useCurrentDialog();
  return createElement(Trigger$1, Object.assign({}, dialog.props, props, {
    ref: mergeRefs([dialog.ref, ref]),
    asChild: true
  }));
});

export { Trigger };
//# sourceMappingURL=Trigger.js.map
